import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import ProfileRow from "./ProfileRow";
import AccordionRow from "./AccordionRow";
import AccordionParticipantRow from "./AccordionParticipantRow";
import { aggregateApplicationData } from "../../helper/profileCalculations";
import React, { useState } from "react";
import "./ProfileTable.css";

const ProfileTable = ({
  profile,
  properties,
  loadData,
  user,
  openAssignLLModal,
  checkSalary,
  rentPercentage,
  rentDoc,
  tenantChecks = false,
  deaWorkspace,
  loading = false,
}) => {
  const { _t } = useTranslator();
  const [openAccordionId, setOpenAccordionId] = useState(null);

  const toggleAccordion = (profileId) => {
    setOpenAccordionId(openAccordionId === profileId ? null : profileId);
  };

  return (
    <div className="profile-table-scroll">
      <table className="profile-table">
        <caption className="skor-details d-none"></caption>

        <thead className="hideOnMobile">
          <tr>
            <th className="tenant-col">{_t("tenant")}</th>
            <th className="skor-details-column">{_t("skor")}</th>
            <th>{_t("income")}</th>
            <th>{_t("maxRent", "Field in profile table")}</th>
            {/* <th>{_t("flatmates")}</th> */}
            {/* <th> {_t("members")} </th> */}
            <th>{_t("guarantors")}</th>
            <th>{_t("linkedProperties", "Field in profile table")}</th>
            {!tenantChecks && <th>{_t("docs")}</th>}
            <th className="updated-col">
              {_t("infoUpdatedAt", "Field in profile table")}
            </th>
            <th className="action-col"></th>
          </tr>
        </thead>

        <tbody>
          {haveValue(profile)
            ? profile
                .filter((data) => !data.deleted)
                .map((data) => {
                  if (data?.application_id?.participants?.length > 0) {
                    const aggregatedData = aggregateApplicationData(
                      data,
                      user,
                      _t,
                      deaWorkspace,
                      checkSalary
                    );
                    const isOpen = openAccordionId === data._id;
                    return (
                      <React.Fragment key={data._id}>
                        <AccordionRow
                          profile={data}
                          aggregatedData={aggregatedData}
                          properties={properties}
                          loadData={loadData}
                          isOpen={isOpen}
                          onToggle={() => toggleAccordion(data._id)}
                          totalParticipants={
                            data?.application_id?.participants?.length
                          }
                          tenantChecks={tenantChecks}
                        />
                        {isOpen &&
                          data.application_id.participants
                            ?.filter((p) => !p.deleted)
                            .map((participant, index) => (
                              <AccordionParticipantRow
                                key={`${data._id}-participant-${index}`}
                                profile={data}
                                participant={participant}
                                isPending={
                                  !participant.is_deleted &&
                                  participant.consent_status !== "accepted"
                                }
                                isOwner={
                                  !participant.is_deleted &&
                                  participant.id ===
                                    data?.application_id?.created_by
                                }
                                tenantChecks={tenantChecks}
                              />
                            ))}
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <ProfileRow
                        key={data._id}
                        profile={data}
                        properties={properties}
                        loadData={loadData}
                        openAssignLLModal={openAssignLLModal}
                        checkSalary={checkSalary}
                        rentPercentage={rentPercentage}
                        rentDoc={rentDoc}
                        tenantChecks={tenantChecks}
                      />
                    );
                  }
                })
            : _t("noDetailsFound")}
        </tbody>
      </table>
    </div>
  );
};

export default ProfileTable;
